import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Dropdown } from '@ibk/shared-ui';
import { useFinancialInstitutionsSelect } from '../../hooks/useFinancialInstitutionsSelect';
export function FinancialInstitutionsSelect(props) {
    const { loading, error, institutionOptions, handleChange } = useFinancialInstitutionsSelect();
    return (_jsx(Dropdown, { options: institutionOptions, value: props.value?.code, label: props.label, placeholder: props.placeholder, onChange: e => handleChange(e, props.onChange), dataTestId: `${props.dataTestId}-dropdown`, size: 'large', searchable: true, searchPlaceholder: props.searchPlaceholder ?? '', disabled: loading, error: error, loading: loading }));
}
